var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4C9.88621 4.02558 7.86621 4.87664 6.37142 6.37142C4.87664 7.86621 4.02558 9.88621 4 12C4.02558 14.1138 4.87664 16.1338 6.37142 17.6286C7.86621 19.1234 9.88621 19.9744 12 20C14.1138 19.9744 16.1338 19.1234 17.6286 17.6286C19.1234 16.1338 19.9744 14.1138 20 12C19.9744 9.88621 19.1234 7.86621 17.6286 6.37142C16.1338 4.87664 14.1138 4.02558 12 4ZM16.5714 12.5714H12.5714V16.5714H11.4286V12.5714H7.42857V11.4286H11.4286V7.42857H12.5714V11.4286H16.5714V12.5714Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRound);
export default __webpack_public_path__ + "static/media/Add_round.50808696e072fa179ce4473b9c75fc04.svg";
export { ForwardRef as ReactComponent };